// config/index.js — environment and runtime configuration.
// For static app-level constants (copy, UI defaults), see utils/config.js.

import { getUrl } from "@/hooks/useAssets";

// Convenience flags — use these instead of import.meta.env.DEV directly
export const isDev = Boolean(import.meta.env.DEV);
export const isProd = Boolean(import.meta.env.PROD);

const toBool = (value) => {
    const normalized = String(value ?? "").trim().toLowerCase();
    return normalized === "1" || normalized === "true" || normalized === "yes" || normalized === "on";
};

const toNumber = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};

// Warn in dev if required env vars are missing
if (import.meta.env.DEV && !import.meta.env.VITE_API_BASE_URL) {
    console.warn("[config] VITE_API_BASE_URL is not set — falling back to '/'");
}

export const config = Object.freeze({
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "/",
    apiTimeout: toNumber(import.meta.env.VITE_API_TIMEOUT, 1000 * 60 * 10), // 0 for Infinite
    mapDefaultCenter: Object.freeze({
        lat: 40.7128,
        lng: -74.006,
    }),
    mapDefaultZoom: toNumber(import.meta.env.VITE_MAP_DEFAULT_ZOOM, 12),
    maxFileSize: toNumber(import.meta.env.VITE_MAX_FILE_SIZE, 5 * 1024 * 1024),
    allowedImageTypes: Object.freeze(["image/jpeg", "image/png", "image/webp"]),
    debounceDelay: toNumber(import.meta.env.VITE_DEBOUNCE_DELAY, 300),
    features: Object.freeze({
        enableNotifications: toBool(import.meta.env.VITE_ENABLE_NOTIFICATIONS),
        enableAnalytics: toBool(import.meta.env.VITE_ENABLE_ANALYTICS),
    }),
});

export default config;

export const languages = [
    {
        value: "en",
        label: "English",
        img: getUrl("/images/language-en.svg"),
    },
    {
        value: "fr",
        label: "French",
        img: getUrl("/images/language-fr.svg"),
    },
    {
        value: "pt",
        label: "Portuguese",
        img: getUrl("/images/language-pt.svg"),
    },
    {
        value: "es",
        label: "Spanish",
        img: getUrl("/images/language-es.svg"),
    },
    {
        value: "hi",
        label: "Hindi",
        img: getUrl("/images/language-hi.svg"),
    },
]
